<template>
  <div class="view pa24">
    <div class="d-flex align-items-center">
<!--      <h3 class="cA1 mr10">-->
<!--        已回款<span style="color: rgb(81, 203, 205)">{{-->
<!--          moneyBack | formatMoney-->
<!--        }}</span-->
<!--        >港元，待回款{{ noMoneyBack | formatMoney }}港元-->
<!--      </h3>-->
<!--      <span>注：确认收货后回款才到账</span>-->
    </div>
    {{ getOrderStatusText() }}：
    <el-radio
      v-model="radioValue"
      class="mr10"
      style="margin: 0"
      label=""
      border
      size="medium"
      >{{ getAllOrdersText() }}</el-radio
    >
    <el-radio
      v-model="radioValue"
      class="mr10"
      style="margin: 0"
      label="0"
      border
      size="medium"
      >{{ getPendingAccountText() }}</el-radio
    >
    <el-radio
      v-model="radioValue"
      class="mr10"
      style="margin: 0"
      label="1"
      border
      size="medium"
      >{{ getSettledText() }}</el-radio
    >
    <div style="float: left;margin-right: 10px;">
      {{ getOrderNumberText() }}:
              <el-input :placeholder="getOrderNumberPlaceholder()" v-model="ordersNo" style="width:230px;"></el-input>
    </div>
    <el-button type="primary" @click="selectCompanyTransferList"
              >{{ getSearchText() }}</el-button
    >
    <commonTable
      :tableData="tableData"
      :loading="loading"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage"
      :total="total"
    >
      <template v-slot:table>
        <el-table-column
          prop="ordersNo"
          align="center"
          :label="getOrderNumberText()"
          show-overflow-tooltip
        />
        <el-table-column prop="goodsName" align="center" show-overflow-tooltip :label="getGoodsNameText()" />
        <el-table-column prop="orderAmount" align="center" :label="getPaymentAmountText()">
          <template slot-scope="scope">
            {{ scope.row.payPrice ? (scope.row.orderAmount / 100).toFixed(2) : 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="royaltyMoney" align="center" :label="getDistributionCommissionText()">
          <template slot-scope="scope">
            {{
              scope.row.commissionAmount
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="transferAmount"
          align="center"
          :label="getDistributionTypeText()"
        >
          <template slot-scope="scope">
            {{
              scope.row.level == 1 ? getFirstLevelDistributionText() :  scope.row.level == 2 ? getSecondLevelDistributionText() : ''
            }}
          </template>
        </el-table-column>
        <el-table-column prop="distributor" align="center" :label="getDistributorNameText()" />
        <el-table-column prop="distributorPhone" align="center" :label="getDistributorPhoneText()" />
        <el-table-column prop="payTime" align="center" show-overflow-tooltip :label="getPaymentTimeText()">
          <template slot-scope="scope">
            {{ scope.row.payTime | getDataTimeSec }}
          </template>
        </el-table-column>
        <el-table-column prop="nickeName" align="center" show-overflow-tooltip :label="getPayerNameText()" />
        <el-table-column prop="phone" align="center" :label="getContactText()" />
        <el-table-column prop="orderStatus" align="center" :label="getCommissionStatusText()">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.status == 0 ? '#ff0a0a' :'#51CDCB' }">{{
              scope.row.status == 1 ? getSettledText() : getPendingSettlementText()
            }}</span>
          </template>
        </el-table-column>
      </template>
    </commonTable>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import customPopconfirm from "@/components/common/customPopconfirm";
import { getDataTimeSec } from "@/utils";
import { selectCompanyTransferList, updateCompanyTransferState } from "@/api/distribution";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  mixins: [i18nMixin],
  name: "accountTransfer",
  components: {
    commonTable
  },
  data() {
    return {
      radioValue: "",
      tableData: [],
      ordersNo:"",
      currentPage: 1, //当前页
      pageSize: 10, //显示条数
      pageSize2: 10, //显示条数
      loading: false, //表格加载
      total: 0, //总条数
      moneyBack: 0,
      noMoneyBack: 0,
    };
  },
  filters: {
    getDataTimeSec(val) {
      return getDataTimeSec(val);
    },
    formatMoney(val) {
      return val ? (val / 100).toFixed(2) : 0;
    },
  },
  created() {
    this.selectCompanyTransferList();
    
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  },
  methods: {
    async selectCompanyTransferList() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        state: this.radioValue,
        ordersNo:this.ordersNo
      };
      try {
        this.loading = true;
        const result = await selectCompanyTransferList(data);
        this.loading = false;
        const {
          pageInfo: { total, list },
          moneyBack,
          noMoneyBack,
        } = result?.data;
        this.tableData = list;
        this.total = total;
        this.moneyBack = moneyBack;
        this.noMoneyBack = noMoneyBack;
      } catch (error) {
        this.loading = false;
        this.tableData = [];
        console.log(error);
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.selectCompanyTransferList()
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.selectCompanyTransferList()
    },
   async changeState(val){
     try {
       await updateCompanyTransferState({transferId:val.transferId});
       this.selectCompanyTransferList();
     } catch (error) {
       console.log(error)
     }
         },
     
     // 多语言方法
    getCurrentLanguage() {
      let currentLanguage = this.$store.state.currentLanguage;
      if (!currentLanguage) {
        currentLanguage = localStorage.getItem('language') || 'zh-TW';
      }
      return currentLanguage;
    },
    
    getOrderStatusText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '订单状态',
        'zh-TW': '訂單狀態',
        'en': 'Order Status'
      };
      return textMap[currentLanguage] || '订单状态';
    },
    
    getOrderNumberText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '订单编号',
        'zh-TW': '訂單編號',
        'en': 'Order Number'
      };
      return textMap[currentLanguage] || '订单编号';
    },
    
    getOrderNumberPlaceholder() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '请输入订单编号',
        'zh-TW': '請輸入訂單編號',
        'en': 'Please enter order number'
      };
      return textMap[currentLanguage] || '请输入订单编号';
    },
    
    getSearchText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '搜索',
        'zh-TW': '搜索',
        'en': 'Search'
      };
      return textMap[currentLanguage] || '搜索';
    },
    
    getGoodsNameText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '商品名称',
        'zh-TW': '商品名稱',
        'en': 'Product Name'
      };
      return textMap[currentLanguage] || '商品名称';
    },
    
    getPaymentAmountText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '付款金额（港元）',
        'zh-TW': '付款金額（港元）',
        'en': 'Payment Amount (Yuan)'
      };
      return textMap[currentLanguage] || '付款金额（港元）';
    },
    
    getDistributionCommissionText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '分销佣金',
        'zh-TW': '分銷佣金',
        'en': 'Distribution Commission'
      };
      return textMap[currentLanguage] || '分销佣金';
    },
    
    getDistributionTypeText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '分销类型',
        'zh-TW': '分銷類型',
        'en': 'Distribution Type'
      };
      return textMap[currentLanguage] || '分销类型';
    },
    
    getFirstLevelDistributionText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '一级分销',
        'zh-TW': '一級分銷',
        'en': 'First Level Distribution'
      };
      return textMap[currentLanguage] || '一级分销';
    },
    
    getSecondLevelDistributionText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '二级分销',
        'zh-TW': '二級分銷',
        'en': 'Second Level Distribution'
      };
      return textMap[currentLanguage] || '二级分销';
    },
    
    getDistributorNameText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '分销员姓名',
        'zh-TW': '分銷員姓名',
        'en': 'Distributor Name'
      };
      return textMap[currentLanguage] || '分销员姓名';
    },
    
    getDistributorPhoneText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '分销员电话',
        'zh-TW': '分銷員電話',
        'en': 'Distributor Phone'
      };
      return textMap[currentLanguage] || '分销员电话';
    },
    
    getPaymentTimeText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '付款时间',
        'zh-TW': '付款時間',
        'en': 'Payment Time'
      };
      return textMap[currentLanguage] || '付款时间';
    },
    
    getPayerNameText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '付款人姓名',
        'zh-TW': '付款人姓名',
        'en': 'Payer Name'
      };
      return textMap[currentLanguage] || '付款人姓名';
    },
    
    getContactText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '联系方式',
        'zh-TW': '聯繫方式',
        'en': 'Contact'
      };
      return textMap[currentLanguage] || '联系方式';
    },
    
    getCommissionStatusText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '佣金状态',
        'zh-TW': '佣金狀態',
        'en': 'Commission Status'
      };
      return textMap[currentLanguage] || '佣金状态';
    },
    
    getSettledText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '已结算',
        'zh-TW': '已結算',
        'en': 'Settled'
      };
      return textMap[currentLanguage] || '已结算';
    },
    
    getPendingSettlementText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '待结算',
        'zh-TW': '待結算',
        'en': 'Pending Settlement'
      };
      return textMap[currentLanguage] || '待结算';
    },
    
    getAllOrdersText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '全部订单',
        'zh-TW': '全部訂單',
        'en': 'All Orders'
      };
      return textMap[currentLanguage] || '全部订单';
    },
    
    getPendingAccountText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '待入账',
        'zh-TW': '待入賬',
        'en': 'Pending Account'
      };
      return textMap[currentLanguage] || '待入账';
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
